import React from 'react'
import {Media} from "reactstrap";
import Button from "reactstrap/es/Button";
import paymentTypeHelpers from "../../helpers/PaymentTypeHelper";
import localeHelpers from "../../helpers/LocaleHelper";
import LocalizedStrings from "react-localization";
import {common_strings} from "../../translations/common_translations";

let commonStrings = new LocalizedStrings(common_strings);

const propTypes = {};

class CashierTransactionRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            transaction: props.transaction,
            type: "income",
            paymentType: "cash",
            currency: props.currency,
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // if (prevState.added != this.state.added) {
        //     this.setState({added: prevState.added})
        // }
    }

    getPT() {
        if (this.state.transaction != null && this.state.transaction.pt) {
            let pm = paymentTypeHelpers.paymentTypes().find(p => p.value === this.state.transaction.pt);

            if (pm === undefined) {
                pm = paymentTypeHelpers.paymentTypes()[paymentTypeHelpers.paymentTypes().length - 1].label
            }

            return pm.label
        } else {
            return "?"
        }
    }

    render() {
        this.localize();

        return (
            <tr>
                <th scope="row">
                    <Media className="align-items-center">
                        <Media>
                            <span className="mb-0 text-sm">
                                {this.state.transaction.name || this.state.transaction.title}
                            </span>
                        </Media>
                    </Media>
                </th>
                <td>
                    {this.getPT()}
                </td>
                <td>
                    <span className="mb-0 text-sm">
                        {this.state.currency + this.state.transaction.price}
                    </span>
                </td>
                <td className="text-right align-content-end">
                    <Button
                        onClick={e => this.props.transaction.added ? this.props.removeTransaction(e, this.state.transaction, this.getTransactionType()) : this.props.addTransaction(e, this.state.transaction, this.getTransactionType())}
                        size="sm"
                        color="warning"
                    >
                        {this.buttonName()}
                    </Button>
                </td>
            </tr>
        )
    }

    getTransactionType() {
        switch (this.state.transaction.pt) {
            case "c":
                return "cash";
            case "cc":
                return "cc";
            case "b":
                return "bank";
            case "p":
                return "bank";
            case "w":
                return "bank";
            case "i":
                return "bank";
            case "s":
                return "bank";
            default:
                return "cash";
        }
    }

    localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
    }

    buttonName() {
        return this.state.transaction.added ? commonStrings.remove : commonStrings.add
    }
}

CashierTransactionRow.propTypes = propTypes;

export default CashierTransactionRow;